import React, { useState } from "react";
import UserService from "../services/UserService";
import firebase from "../services/FirebaseService";
import { Redirect } from "react-router-dom";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "../assets/style/edit-profile.css";
import { AuthProvider, IfFirebaseAuthed, IfFirebaseUnAuthed } from "../context/FirebaseAuthContext";

const Dialog = ({ user }) => {

	const userService = new UserService();

	const [ pending, setPending ] = useState(false);
	const [ success, setSuccess ] = useState(false);
	const [ input, setInput ] = useState({
		name: user.name ? user.name : "",
		location: user.location ? user.location : "",
		about: user.about ? user.about : ""
	});


	const handleInput = ({ target }) => {
		setInput({
			...input,
			[target.name]: target.value
		});
	};

	const updateProfile = async (e) => {
		e.preventDefault();
		setPending(true);
		
		try {
			await userService.updateProfile(user.uid, input.name, input.location, input.about);
			setPending(false);
			setSuccess(true);
		}
		catch(error) {
			console.error(error);
			setSuccess(false);
			setPending(false);
		}
	};

	return (
 
			<section id="edit-profile">
				{ success && <Redirect to="/self-profile" /> }
				<div id="picture">
					<img alt="personal" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.istockphoto.com%2Fvectors%2Fprofile-placeholder-image-gray-silhouette-no-photo-vector-id1016744004%3Fk%3D6%26m%3D1016744004%26s%3D170667a%26w%3D0%26h%3DdsibM8vNYIJDN1wtB8SWex8M99vl6a9NoDsobZ9dUCo%3D&f=1&nofb=1" />
					<p id="warn">Profile picture customization will be available soon.</p>
				</div>
				<form onSubmit={e => updateProfile(e)}>
					<div className="text">
						<h2>Name</h2>
						<input 
							name="name"
							type="text"
							placeholder="John Smith"
							defaultValue={user.name}
							onChange={e => handleInput(e)}
							disabled={pending}
						/>
					</div>
					<div className="text">
						<h2>Location</h2>
						<input 
							name="location"
							type="text"
							placeholder="New York"
							defaultValue={user.location}
							onChange={e => handleInput(e)}
							disabled={pending}
						/>
					</div>
					<div id="about">
						<h2>About Me</h2>
						<textarea 
							name="about"
							rows="20" 
							placeholder="Hello! I'm John Smith."
							defaultValue={user.about}
							onChange={e => handleInput(e)}
							disabled={pending}
						></textarea>
					</div>
					<button 
						type="submit" 
						disabled={pending}
					>Save</button>
				</form>
			</section>
	);
}

const Info = () => {
	const userService = new UserService();

	const [ userObject, setUser ] = useState();
	const [ loading, setLoading ] = useState(true);
	
	
	if(loading) {
		firebase.auth().onAuthStateChanged(async user => {
			if(user) {
				setLoading(false);

				try {
					const userTemp = await userService.getUserInfo(user.uid);
	
					setUser(userTemp);
				}
				catch(error) {
					console.error(error);
				}
			}
		})
	}
	return (
		<>
			{ userObject && <Dialog user={userObject} /> }
		</>
	)
};


const EditProfilePage = () => {

	return (
		<>
			<AuthProvider>
				<IfFirebaseAuthed>
					<Navbar />
					<Info />
					<Footer />
				</IfFirebaseAuthed>
				<IfFirebaseUnAuthed>
					<Redirect to="/auth/login" />
				</IfFirebaseUnAuthed>
			</AuthProvider>
		</>
	)
};

export default EditProfilePage;